// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ONE_DAY } from '@shared/Enums'
import { ethers } from 'ethers'

export const localAdvanceDays = async (provider: ethers.JsonRpcProvider, numberDays: number): Promise<void> => {
  const blockNumberStart = await provider.getBlockNumber()
  const blockStart = await provider.getBlock(blockNumberStart - 1)
  const timestampStart = blockStart?.timestamp ?? 0
  const increase = Math.round(numberDays * 24 * 3600)

  await provider.send('evm_increaseTime', [increase + 20])
  await provider.send('evm_mine', [])
  const blockEnd = await provider.getBlock('latest')

  let timestampNow = blockEnd?.timestamp ?? 0
  while (timestampNow < timestampStart + increase) {
    await await new Promise((resolve) => setTimeout(resolve, 100))
    await provider.send('evm_mine', [])
    const blockEnd = await provider.getBlock('latest')
    //    logOTShared.debug('wait')
    timestampNow = blockEnd?.timestamp ?? 0
  }
}
export const localAdvanceHours = async (provider: ethers.JsonRpcProvider, numberHours: number): Promise<void> => {
  const blockNumberStart = await provider.getBlockNumber()
  const blockStart = await provider.getBlock(blockNumberStart - 1)
  const timestampStart = blockStart?.timestamp ?? 0
  const increase = Math.round(numberHours * 3600)

  await provider.send('evm_increaseTime', [increase + 20])
  await provider.send('evm_mine', [])
  const blockEnd = await provider.getBlock('latest')

  let timestampNow = blockEnd?.timestamp ?? 0
  while (timestampNow < timestampStart + increase) {
    await await new Promise((resolve) => setTimeout(resolve, 100))
    await provider.send('evm_mine', [])
    const blockEnd = await provider.getBlock('latest')
    //    logOTShared.debug('wait')
    timestampNow = blockEnd?.timestamp ?? 0
  }
}

export const localAdvanceToMidnight = async (provider: ethers.JsonRpcProvider): Promise<void> => {
  const blockNumberB = await provider.getBlockNumber()
  const timestampStart = (await provider.getBlock(blockNumberB))?.timestamp ?? 0

  const timeOfDay = timestampStart % ONE_DAY
  const timeToAdvance = Math.round(ONE_DAY - timeOfDay)

  await provider.send('evm_mine', [])

  await provider.send('evm_increaseTime', [timeToAdvance + 10])
  await provider.send('evm_mine', [])

  const blockEnd = await provider.getBlock('latest')

  let timestampNow = blockEnd?.timestamp ?? 0
  while (timestampNow < timestampStart + timeToAdvance) {
    await new Promise((resolve) => setTimeout(resolve, 100))
    await provider.send('evm_mine', [])
    const blockEnd = await provider.getBlock('latest')
    //    logOT.info('wait')
    timestampNow = blockEnd?.timestamp ?? 0
  }
}

export const localAdvanceToTime = async (
  provider: ethers.JsonRpcProvider,
  hour: number,
  followOnIncreases?: number[]
): Promise<void> => {
  await provider.send('evm_mine', [])
  const blockStart = await provider.getBlock('latest')

  const timestampStart = blockStart?.timestamp ?? 0

  const startTimeOfDay = timestampStart % (24 * 3600)
  const targetTimeOfDay = Math.round(hour * 3600)

  let delta = targetTimeOfDay - startTimeOfDay
  while (delta < 100) {
    delta += 24 * 3600
  }

  //  provider.pollingInterval = 100

  await provider.send('evm_mine', [])
  await provider.send('evm_increaseTime', [delta + 60])
  await provider.send('evm_mine', [])

  let blockCurrent = await provider.getBlock('latest')
  let timestampEnd = blockCurrent?.timestamp ?? 0

  while (timestampEnd < timestampStart + delta) {
    await provider.send('evm_mine', [])
    await new Promise((resolve) => setTimeout(resolve, 10))

    blockCurrent = await provider.getBlock('latest')
    timestampEnd = blockCurrent?.timestamp ?? 0
  }

  if (followOnIncreases) {
    for (const increase of followOnIncreases) {
      timestampEnd += increase

      await provider.send('evm_mine', [])
      await provider.send('evm_increaseTime', [increase + 60])
      await provider.send('evm_mine', [])
    }
    let timestampCurrent = (await provider.getBlock('latest'))?.timestamp ?? 0
    while (timestampCurrent < timestampEnd) {
      await provider.send('evm_mine', [])
      await new Promise((resolve) => setTimeout(resolve, 10))

      timestampCurrent = (await provider.getBlock('latest'))?.timestamp ?? 0
    }
  }
}

export const advanceTimeInHours = async (providerJsonRpc: ethers.JsonRpcProvider, hours: number): Promise<Date> => {
  const blockNumberB = await providerJsonRpc.getBlockNumber()
  const timestampStart = (await providerJsonRpc.getBlock(blockNumberB))?.timestamp ?? 0

  await providerJsonRpc.send('evm_mine', [])

  const increase = Math.round(hours * 3600)
  let currentIncrease = 0
  while (currentIncrease < increase + 10) {
    const step = Math.min(increase + 10 - currentIncrease, 3600)

    await providerJsonRpc.send('evm_increaseTime', [step])

    await providerJsonRpc.send('evm_mine', [])
    currentIncrease += step
  }
  // await providerJsonRpc.send('evm_increaseTime', [increase + 10])
  await providerJsonRpc.send('evm_mine', [])

  const blockEnd = await providerJsonRpc.getBlock('latest')

  let timestampNow = blockEnd?.timestamp ?? 0
  while (timestampNow < timestampStart + increase) {
    await new Promise((resolve) => setTimeout(resolve, 100))
    await providerJsonRpc.send('evm_mine', [])
    const blockEnd = await providerJsonRpc.getBlock('latest')
    //    logOT.info('wait')
    timestampNow = blockEnd?.timestamp ?? 0
  }

  const timestampEnd = (await providerJsonRpc.getBlock('latest'))?.timestamp ?? 0

  const newDate = new Date(timestampEnd * 1000)

  return newDate
}
